import { decodeItemId, encodeItemId } from '../parsers/item-id';
import { ItemKind } from '../../../constants/ItemKind';
export function toFolder(folder, parentFolderId) {
  const {
    siteMediaToken
  } = decodeItemId(parentFolderId);
  return {
    ...folder,
    kind: ItemKind.Folder,
    id: encodeItemId(siteMediaToken, folder.id),
    source: 'wixSite',
    parentId: encodeItemId(siteMediaToken, folder.parentId)
  };
}
export function toOldMediaFolder(folder) {
  return {
    ...folder,
    kind: ItemKind.Folder,
    name: folder.folder_name,
    id: encodeItemId(null, folder.folder_id),
    source: 'wixSite',
    parentId: encodeItemId(null, null),
    // All My Files
    tags: folder.tags || []
  };
}